<app-data-chart-box [title]="title">
  <div class="temperature-wrapper">
    <div class="temperature-chart" echarts [options]="chartOption"></div>
  </div>
</app-data-chart-box>
